module.exports = __webpack_public_path__ + "img/icon-directions.331260f9.svg";